import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";

export function useFeatureTargetingData(featureId?: string) {
  const { app } = useEnvironment();

  return useQuery({
    queryKey: featureQueryKeys.targeting(app.id, undefined, featureId),
    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/targeting">(
          `/apps/${app.id}/features/${featureId}/targeting`,
        )
        .then((res) => res.data.currentVersions),
    enabled: !!featureId,
  });
}
